import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react"

import GlobalLoader from "@fuse/sharedComponents/globalLoader/GlobalLoader"

interface GlobalLoaderContextType {
  loading: boolean
  showLoader: () => void
  hideLoader: () => void
}

const GlobalLoaderContext = createContext<GlobalLoaderContextType | undefined>(
  undefined,
)

export const GlobalLoaderProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(false)

  const showLoader = useCallback(() => setLoading(true), [])
  const hideLoader = useCallback(() => setLoading(false), [])

  return (
    <GlobalLoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      <GlobalLoader />
      {children}
    </GlobalLoaderContext.Provider>
  )
}

export const useGlobalLoader = () => {
  const context = useContext(GlobalLoaderContext)
  if (!context) {
    throw new Error(
      "useGlobalLoader must be used within a GlobalLoaderProvider",
    )
  }
  return context
}
